export function interval(func, wait) {
  let stop = false;
  const loop = (function(w) {
    return () => {
      if (!stop) {
        setTimeout(loop, w);
        try {
          func.call(null);
        } catch (e) {
          stop = true;
          throw e.toString();
        }
      }
    };
  })(wait);

  return {
    start: () => {
      setTimeout(loop, wait);
    },
    stop: () => {
      stop = true;
    },
  };
}

export class Stopwatch {
  constructor(initialVal = 0) {
    this.val = initialVal;
    this.startdate = null;
  }
  start() {
    this.startdate = Date.now();
  }
  stop() {
    this.val = this.val + Date.now() - this.startdate;
    this.startdate = null;
  }
  reset() {
    this.val = 0;
    this.startdate = null;
  }
  get value() {
    return this.startdate ? this.val + Date.now() - this.startdate : this.val;
  }
}
